import React from 'react';
import './Catalogues.css';
import { trackPDFDownload } from '../services/trackingService';

// Import des PDF depuis le dossier src/pdf
import LivretAccueil from '../pdf/Livret-daccueil.pdf';
import CatalogueGeneral from '../pdf/Catalogue.pdf';
import CertificationQualiopi from '../pdf/Qualiopi.pdf';
import CertificationLilate from '../pdf/LILATE.pdf';
import CertificationLeveltel from '../pdf/CertificationLEVELTEL.pdf';
import CharteCPF from '../pdf/chartecpf.pdf';
import TestAptitudeAnglais from '../pdf/certififcation-lilate.pdf';
import ModalitesFormation from '../pdf/Modalités.pdf';

// Import de l'image de formation
import formationImage from '../images/why_1.jpg';

const Catalogues = () => {
    const catalogues = [
        {
            title: "Livret d'accueil / Règlement intérieur",
            link: LivretAccueil
        },
        {
            title: "Catalogue général",
            link: CatalogueGeneral
        },
        {
            title: "Certification Qualiopi",
            link: CertificationQualiopi
        },
        {
            title: "CERTIFICATION LILATE",
            link: CertificationLilate
        },
        {
            title: "Certification LEVELTEL",
            link: CertificationLeveltel
        },
        {
            title: "CHARTE CPF",
            link: CharteCPF
        }
    ];

    return (
        <div id="Formationsprofessionnelles" className="why">
            <div className="container">
                <div className="row row-eq-height">
                    <div className="col-lg-6 order-lg-1 order-2"><br />
                        <div className="why_image_container">
                            <div className="why_image">
                                <img src={formationImage} alt="Formation linguistique" loading="lazy" decoding="async" width="560" height="420" />
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 order-lg-2 order-1">
                        <div className="why_content">
                            <div className="extra_disc d-flex flex-row align-items-end justify-content-start">
                                <div><span>Nos</span> catalogues</div>
                            </div>

                            <div className="catalogues_links">
                                {catalogues.map((catalogue, index) => (
                                    <div key={index} className="button button_1 extra_link trans_200">
                                        <a href={catalogue.link} target="_blank" rel="noopener noreferrer" onClick={() => trackPDFDownload(catalogue.title)}>
                                            {catalogue.title}
                                        </a>
                                    </div>
                                ))}
                            </div>

                            <div className="certification_section">
                                <div className="cta_category">
                                    Certification incluse dans le prix de nos formations anglais
                                </div>
                                <div className="button button_1 extra_link2 trans_200">
                                    <a href={TestAptitudeAnglais} target="_blank" rel="noopener noreferrer" onClick={() => trackPDFDownload('Test aptitude anglais')}>
                                        TEST D'APTITUDE EN ANGLAIS
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section Processus */}
                <div className="process_section">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="extra_disc d-flex flex-row align-items-end justify-content-start">
                                    <div>Processus d'inscription et de suivi de l'action de formation</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section PDF Embed */}
                <div className="pdf_section">
                    <div className="container">
                        <div className="pdf_container">
                            <embed
                                src={ModalitesFormation}
                                className="pdf-embed"
                                type="application/pdf"
                                title="Modalités de formation"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Catalogues;
